<template>
  <div id="logout"></div>
</template>

<script>
export default {
  name: "Logout",
  computed: {
    isLoggedIn: function() {
      return this.$auth.getters.isLoggedIn;
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("auth/logout").then(response => {
        this.$toastr.success(this.$i18n.t("success.security.logged_out"));
        this.$router.push({ name: "Login" });
      });
    }
  },
  created() {
    this.logout();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Security/logout.vue